import moment from "moment";
import dig from "object-dig";
import _ from "underscore";

import api from "@/helpers/api";
import auth from "@/helpers/auth";

const apiVersion = 'v1';
const source = 'conversations';

export default {
  state: {
    all: [],
    current: null,
    hasMore: false,
    currentPage: 0,
    testMode: false,
    filters: {
      status: "all",
      flag_status: "all",
      from: null,
      to: null,
      name: "",
      context: []
    }
  },

  mutations: {
    addConversations(state, conversations) {
      const firstFetch = state.all.length === 0;

      const all = state.all;
      _.each(conversations, (convo) => {
        if (
          !_.find(all, (c) => {
            return c.id === convo.id;
          })
        )
          console.log("convo assign");
        console.log(convo);
          all.push(convo);
          console.log("convo assign end");

      });

      state.all = all;

      if (firstFetch) state.current = conversations[0];
    },

    setCurrentConversation(state, conversation) {
      state.current = conversation;
    },

    updateConverstation(state, conversation) {
      state.all = _.map(state.all, (c) => {
        if (c.id !== conversation.id) return c;
        return conversation;
      });

      if (state.current && state.current.id === conversation.id) {
        state.current.blacklisted = conversation.blacklisted;
        state.current.human_in_the_loop = conversation.human_in_the_loop;
      }
    },

    addMessageToConversation(state, { conversationId, message }) {
      const exists = _.find(state.all, (c) => {
        return c.id === conversationId;
      });

      if (!exists) {
        // Filterd out active convos
        if (state.filters.status === "closed") return;
        // Don't want to see recent convos
        if (state.filters.to && state.filters.to < moment().startOf("day")) return;

        api
          .instance()
          .get(`${apiVersion}/${source}/${conversationId}`)
          .then((resp) => {
            const convo = _.extend({}, resp.data.data.attributes, {
              latestMessage: resp.data.included[0]
            });

            let valid = true;

            // validate the convo passes the name filter
            if (state.filters.name) {
              const filterName = state.filters.name.toLowerCase();
              const custName = convo.metadata.context.customer_name.toLowerCase();
              if (custName.indexOf(filterName) === -1) valid = false;
            }

            // validate context filters
            let ctxField;
            _.each(state.filters.context, (ctx) => {
              ctxField = dig(convo, "metadata", "context");
              _.each(ctx.key.split("."), (k) => {
                ctxField = dig(ctxField, k);
              });

              if (String(ctxField) !== ctx.value) valid = false;
            });

            // validate test mode
            if (state.testMode !== convo.test_mode) valid = false;

            if (valid) state.all.unshift(convo);
          })
          .catch((err) => console.error("Failed to fetch conversation", err));
      }

      state.all = _.map(state.all, (c) => {
        if (c.id === conversationId) {
          c.latestMessage = message;
          c.status = "active";
          if (message.customer_id) {
            c.metadata.context.customer_name = message.sender_name;
          }
        }

        return c;
      });
    },

    setHasMoreConversations(state, val) {
      state.hasMore = val;
    },

    incrementConversationsCurrentPage(state) {
      state.currentPage += 1;
    },

    clearConversations(state) {
      state.all = [];
      state.current = null;
      state.currentPage = 0;
      state.hasMore = false;
    },

    setConversationFilters(state, filters) {
      filters = _.clone(filters);

      filters.context = _.select(filters.context, (filter) => {
        return filter.value.length > 0;
      });
      state.filters = filters;
    },

    setTestMode(state, payload) {
      state.testMode = payload;
    }
  },

  actions: {
    fetchConversations({ commit, dispatch, state }, callback = null) {
      const params = {
        team_id: auth.teamId(),
        page: state.currentPage + 1,
        from: state.filters.from,
        to: state.filters.to,
        customer_name: state.filters.name,
        dealership_id: state.filters.dealership_id,
        context: state.filters.context,
        status: state.filters.status,
        flag_status: state.filters.flag_status,
        inc_blacklisted: state.filters.inc_blacklisted,
        test_mode: state.testMode
      };

      return api
        .instance()
        .post(`${apiVersion}/${source}`, params)
        .then((resp) => {
          dispatch("buildConversations", {
            conversations: resp.data.data,
            included: resp.data.included,
            callback: (conversations) => {
              console.log("conversations assign");
              commit("addConversations", conversations);
              commit("incrementConversationsCurrentPage");
              commit("setHasMoreConversations", resp.data.data.length > 0);
    console.log("callback")
              if (callback) callback();
            }
          });
        });
    },

    changeCurrentConversation({ commit, dispatch, state }, conversationId) {
      const convo = _.findWhere(state.all, { id: conversationId });

      if (convo) {
        commit("setCurrentConversation", convo);
      } else {
        api
          .instance()
          .get(`${apiVersion}/${source}/${conversationId}`)
          .then((resp) => {
            dispatch("buildConversations", {
              conversations: [resp.data.data],
              included: resp.data.included,
              callback: (conversations) => {
                commit("addConversations", conversations);
                commit("setCurrentConversation", conversations[0]);
              }
            });
          })
          .catch((err) => console.error("Failed to fetch conversation", err));
      }
    },

    buildConversations({ dispatch }, data) {
      let latestMessage;

      const allConversations = _.map(data.conversations, (convo) => {
        if (_.isObject(convo.relationships.latest_message.data)) {
          latestMessage = _.findWhere(data.included, convo.relationships.latest_message.data);
          if (latestMessage) latestMessage = latestMessage.attributes;
        }

        return _.extend({}, convo.attributes, { latestMessage });
      });

      data.callback(allConversations);
    },

    updateConversation({ commit, state }, params) {
      params.team_id = auth.teamId();

      return api
        .instance()
        .put(`${apiVersion}/${source}/${params.id}`, params)
        .then((resp) => {
          commit("updateConverstation", resp.data.data.attributes);
          if (params.callback) params.callback();

          return resp;
        })
        .catch((err) => console.error("Failed to update conversations", err.response));
    },

    toggleTestMode({ commit, state }) {
      return commit("setTestMode", !state.testMode);
    }
  },

  getters: {}
};
